/** @format */

import * as React from "react";
import Stack from "@mui/material/Stack";
import Snackbar, {SnackbarProps} from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function AlertMessage(
  open: boolean = false,
  message: string,
  alertcolor: any,
  onClose?: SnackbarProps["onClose"]
) {
  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Snackbar open={open} autoHideDuration={6000} onClose={onClose}>
        <Alert severity={alertcolor} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </Stack>
  );
}
